// extracted by mini-css-extract-plugin
export default {"productTitle":"MeetingAndPickup_productTitle__3HoTw"};